/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { hubsHubKioskGetFullStatusPost } from '../fn/hub-kiosk/hubs-hub-kiosk-get-full-status-post';
import { HubsHubKioskGetFullStatusPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-get-full-status-post';
import { hubsHubKioskGetPrinterStatusPost } from '../fn/hub-kiosk/hubs-hub-kiosk-get-printer-status-post';
import { HubsHubKioskGetPrinterStatusPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-get-printer-status-post';
import { hubsHubKioskGetScreenshotPost } from '../fn/hub-kiosk/hubs-hub-kiosk-get-screenshot-post';
import { HubsHubKioskGetScreenshotPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-get-screenshot-post';
import { hubsHubKioskOnConnectedAsyncPost } from '../fn/hub-kiosk/hubs-hub-kiosk-on-connected-async-post';
import { HubsHubKioskOnConnectedAsyncPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-on-connected-async-post';
import { hubsHubKioskOnDisconnectedAsyncPost } from '../fn/hub-kiosk/hubs-hub-kiosk-on-disconnected-async-post';
import { HubsHubKioskOnDisconnectedAsyncPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-on-disconnected-async-post';
import { hubsHubKioskRestartKioskPost } from '../fn/hub-kiosk/hubs-hub-kiosk-restart-kiosk-post';
import { HubsHubKioskRestartKioskPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-restart-kiosk-post';
import { hubsHubKioskSendFullStatusPost } from '../fn/hub-kiosk/hubs-hub-kiosk-send-full-status-post';
import { HubsHubKioskSendFullStatusPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-send-full-status-post';
import { hubsHubKioskSendLogPost } from '../fn/hub-kiosk/hubs-hub-kiosk-send-log-post';
import { HubsHubKioskSendLogPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-send-log-post';
import { hubsHubKioskSendPrinterStatusPost } from '../fn/hub-kiosk/hubs-hub-kiosk-send-printer-status-post';
import { HubsHubKioskSendPrinterStatusPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-send-printer-status-post';
import { hubsHubKioskSendScreenshotPost } from '../fn/hub-kiosk/hubs-hub-kiosk-send-screenshot-post';
import { HubsHubKioskSendScreenshotPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-send-screenshot-post';
import { hubsHubKioskStopDeclarationPost } from '../fn/hub-kiosk/hubs-hub-kiosk-stop-declaration-post';
import { HubsHubKioskStopDeclarationPost$Params } from '../fn/hub-kiosk/hubs-hub-kiosk-stop-declaration-post';

@Injectable({ providedIn: 'root' })
export class HubKioskService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `hubsHubKioskGetFullStatusPost()` */
  static readonly HubsHubKioskGetFullStatusPostPath = '/hubs/HubKiosk/GetFullStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskGetFullStatusPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskGetFullStatusPost$Response(params?: HubsHubKioskGetFullStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskGetFullStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskGetFullStatusPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskGetFullStatusPost(params?: HubsHubKioskGetFullStatusPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskGetFullStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskGetPrinterStatusPost()` */
  static readonly HubsHubKioskGetPrinterStatusPostPath = '/hubs/HubKiosk/GetPrinterStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskGetPrinterStatusPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskGetPrinterStatusPost$Response(params?: HubsHubKioskGetPrinterStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskGetPrinterStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskGetPrinterStatusPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskGetPrinterStatusPost(params?: HubsHubKioskGetPrinterStatusPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskGetPrinterStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskGetScreenshotPost()` */
  static readonly HubsHubKioskGetScreenshotPostPath = '/hubs/HubKiosk/GetScreenshot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskGetScreenshotPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskGetScreenshotPost$Response(params?: HubsHubKioskGetScreenshotPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskGetScreenshotPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskGetScreenshotPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskGetScreenshotPost(params?: HubsHubKioskGetScreenshotPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskGetScreenshotPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskOnConnectedAsyncPost()` */
  static readonly HubsHubKioskOnConnectedAsyncPostPath = '/hubs/HubKiosk/OnConnectedAsync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskOnConnectedAsyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskOnConnectedAsyncPost$Response(params?: HubsHubKioskOnConnectedAsyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskOnConnectedAsyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskOnConnectedAsyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskOnConnectedAsyncPost(params?: HubsHubKioskOnConnectedAsyncPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskOnConnectedAsyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskOnDisconnectedAsyncPost()` */
  static readonly HubsHubKioskOnDisconnectedAsyncPostPath = '/hubs/HubKiosk/OnDisconnectedAsync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskOnDisconnectedAsyncPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskOnDisconnectedAsyncPost$Response(params?: HubsHubKioskOnDisconnectedAsyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskOnDisconnectedAsyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskOnDisconnectedAsyncPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskOnDisconnectedAsyncPost(params?: HubsHubKioskOnDisconnectedAsyncPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskOnDisconnectedAsyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskRestartKioskPost()` */
  static readonly HubsHubKioskRestartKioskPostPath = '/hubs/HubKiosk/RestartKiosk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskRestartKioskPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskRestartKioskPost$Response(params?: HubsHubKioskRestartKioskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskRestartKioskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskRestartKioskPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskRestartKioskPost(params?: HubsHubKioskRestartKioskPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskRestartKioskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskSendFullStatusPost()` */
  static readonly HubsHubKioskSendFullStatusPostPath = '/hubs/HubKiosk/SendFullStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskSendFullStatusPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendFullStatusPost$Response(params?: HubsHubKioskSendFullStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskSendFullStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskSendFullStatusPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendFullStatusPost(params?: HubsHubKioskSendFullStatusPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskSendFullStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskSendLogPost()` */
  static readonly HubsHubKioskSendLogPostPath = '/hubs/HubKiosk/SendLog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskSendLogPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendLogPost$Response(params?: HubsHubKioskSendLogPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskSendLogPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskSendLogPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendLogPost(params?: HubsHubKioskSendLogPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskSendLogPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskSendPrinterStatusPost()` */
  static readonly HubsHubKioskSendPrinterStatusPostPath = '/hubs/HubKiosk/SendPrinterStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskSendPrinterStatusPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendPrinterStatusPost$Response(params?: HubsHubKioskSendPrinterStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskSendPrinterStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskSendPrinterStatusPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendPrinterStatusPost(params?: HubsHubKioskSendPrinterStatusPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskSendPrinterStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskSendScreenshotPost()` */
  static readonly HubsHubKioskSendScreenshotPostPath = '/hubs/HubKiosk/SendScreenshot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskSendScreenshotPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendScreenshotPost$Response(params?: HubsHubKioskSendScreenshotPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskSendScreenshotPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskSendScreenshotPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskSendScreenshotPost(params?: HubsHubKioskSendScreenshotPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskSendScreenshotPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hubsHubKioskStopDeclarationPost()` */
  static readonly HubsHubKioskStopDeclarationPostPath = '/hubs/HubKiosk/StopDeclaration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hubsHubKioskStopDeclarationPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskStopDeclarationPost$Response(params?: HubsHubKioskStopDeclarationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hubsHubKioskStopDeclarationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hubsHubKioskStopDeclarationPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hubsHubKioskStopDeclarationPost(params?: HubsHubKioskStopDeclarationPost$Params, context?: HttpContext): Observable<void> {
    return this.hubsHubKioskStopDeclarationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
